import React from 'react';
import { SingleDesignerChip } from '../DesignerChip';

import './DesignerPageFollowButton.scss';

export const DesignerPageFollowButton: React.FC = () => {
  return (
    <div className="DesignerPageFollowButton">
      <SingleDesignerChip treatment="generic" />
    </div>
  );
};
